import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function TowelDigitizing() {

    const towelSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your logo, artwork, or monogram in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Towel Digitizing", description: "Our experts analyze the towel fabric and optimize stitch density and layout for best results.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch paths, density, and contrast to ensure clarity on towel fabric.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your machine ready embroidery files in DST, PES, JEF, and other formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Towel Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional towel digitizing services in Los Angeles, CA. Get precise embroidery digitizing for towels with fast turnaround. Order your custom towel digitizing today!" />
                <meta name="keywords" content="towel digitizing services, towel embroidery digitizing, custom towel digitizing, embroidery digitizing for towels, Los Angeles towel digitizing, towel digitizing near me, professional towel digitizing" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Towel Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Towel Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/towel1.png" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Texture. Depth. Creative Impact.</span>
                                <h3 className="case-study-title">Professional Towel Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in towel digitizing services in Los Angeles, California, helping businesses, hotels, spas, gyms, and event organizers create high quality embroidered towels with precision and distinction. Towel embroidery digitizing requires careful attention to stitch density and fabric behavior since towel loops can affect how threads lay and how designs appear once embroidered.
                                </p>
                                <p className="case-study-description">
                                    Our experienced digitizers transform your logo, monogram, or custom artwork into optimized stitch files designed specifically for towel embroidery. We ensure your design maintains clarity, contrast, and visual appeal when stitched on terry, velour, or fleece towels. If you’re looking for towel embroidery digitizing near you in Los Angeles, Grand Indigo Embroidery delivers professional, machine ready files that make your towels stand out.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Seamless Fabric Application</span>
                                <h3 className="case-study-title">High Quality Custom Towel Digitizing for Personalized Branding</h3>
                                <p className="case-study-description">
                                    We understand that every towel project has unique requirements — whether you’re branding hotel linens, custom promotional towels, or personalized gifts. Our custom towel digitizing services are tailored to suit the specific size, placement, and fabric of your towels to achieve the best result possible.
                                </p>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we combine technical precision with quality design optimization to ensure that your embroidered towels look clean, detailed, and long lasting. From small restaurant monograms to large spa logos, clients throughout Los Angeles trust us for reliable, fast, and professional towel digitizing services. You can also order towel digitizing online for convenient service and speedy delivery.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/towel2.png" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={towelSteps} />
                                                            
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is towel digitizing?"
                                    answer="Towel digitizing is the process of converting a logo or design into an embroidery file optimized for stitching on towel fabrics."
                                />

                                <FaqItem
                                    question="Do you provide towel digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery offers professional towel digitizing services in Los Angeles, California for local and online clients."
                                />

                                <FaqItem
                                    question="How long does towel digitizing take?"
                                    answer="Most towel digitizing projects are completed within 12–24 hours dependent on design complexity and size."
                                /> 

                                <FaqItem
                                    question="Can I order towel digitizing online?"
                                    answer="Absolutely. You can order towel digitizing services online and receive optimized files quickly."
                                />

                                <FaqItem
                                    question="What towels can use embroidery digitizing?"
                                    answer="We digitize for terry cloth, velour towels, gym towels, spa towels, and personalized gift towels."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
